import { Parser } from "@siteimprove/alfa-parser";
import { Function, Token, } from "../../syntax/index.js";
import { Keyword } from "../textual/keyword.js";
import { Position } from "../position/index.js";
import { Value } from "../value.js";
import { BasicShape } from "./basic-shape.js";
import { Radius } from "./radius.js";
const { map, option, pair, right } = Parser;
/**
 * {@link https://drafts.csswg.org/css-shapes/#funcdef-ellipse}
 *
 * @public
 */
export class Ellipse extends BasicShape {
    static of(rx, ry, center) {
        return new Ellipse(rx, ry, center);
    }
    _rx;
    _ry;
    _center;
    constructor(rx, ry, center) {
        super("ellipse", 
        // TS sees the first as Value.HasCalculation<[R, R, P]>
        Value.hasCalculation(rx, ry, center));
        this._rx = rx;
        this._ry = ry;
        this._center = center;
    }
    get rx() {
        return this._rx;
    }
    get ry() {
        return this._ry;
    }
    get center() {
        return this._center;
    }
    resolve(resolver) {
        return new Ellipse(this._rx.resolve(resolver), this._ry.resolve(resolver), this._center.resolve(resolver));
    }
    partiallyResolve(resolver) {
        return new Ellipse(this._rx.partiallyResolve(resolver), this._ry.partiallyResolve(resolver), this._center.partiallyResolve(resolver));
    }
    equals(value) {
        return (value instanceof Ellipse &&
            value._rx.equals(this._rx) &&
            value._ry.equals(this._ry) &&
            value._center.equals(this._center));
    }
    hash(hash) {
        hash
            .writeHashable(this._rx)
            .writeHashable(this._ry)
            .writeHashable(this._center);
    }
    toJSON() {
        return {
            ...super.toJSON(),
            rx: this._rx.toJSON(),
            ry: this._ry.toJSON(),
            center: this._center.toJSON(),
        };
    }
    toString() {
        return `ellipse(${this._rx} ${this._ry} at ${this._center})`;
    }
}
/**
 * @public
 */
(function (Ellipse) {
    function isEllipse(value) {
        return value instanceof Ellipse;
    }
    Ellipse.isEllipse = isEllipse;
    Ellipse.parse = map(Function.parse("ellipse", pair(option(pair(Radius.parse, right(Token.parseWhitespace, Radius.parse))), option(right(option(Token.parseWhitespace), right(Keyword.parse("at"), right(Token.parseWhitespace, Position.parse())))))), ([_, [radii, center]]) => {
        const [rx, ry] = radii.getOr([
            Radius.of(Keyword.of("closest-side")),
            Radius.of(Keyword.of("closest-side")),
        ]);
        return Ellipse.of(rx, ry, center.getOr(Position.of(Keyword.of("center"), Keyword.of("center"))));
    });
})(Ellipse || (Ellipse = {}));
//# sourceMappingURL=ellipse.js.map